import axios from 'axios'

export default {
    getTickets(page, filter, sorting) {
        var params = {
            page: page,
            customer: filter.customer,
            customerId: filter.customerId,
            ticket: filter.ticket,
            city: filter.city,
            serviceCompany: filter.serviceCompany,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serialNumber: filter.serialNumber,
            state: filter.state,
            chainId:filter.chainId,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder,
            source: filter.source
        };
        if (filter.type !== 0) {
            params.status = filter.type
        }
        return axios.get('/api/servicetickets',
            {
                params: params
            });
    },
    getTicket(id) {
        return axios.get(`/api/servicetickets/${id}`);
    },
    saveTicket(dispatch, ticket, number, changeEmail) {
        var fd = new FormData();
        for (let prop in ticket) {
            if (ticket.hasOwnProperty(prop)) {
                if (prop === 'attachments') {
                    for (let i = 0; i < ticket.attachments.length; i++) {
                        if (ticket.attachments[i] instanceof File) {
                            fd.append(`attachments`, ticket.attachments[i]);
                        }
                    }
                } else if (prop === 'complaintCodes') {
                    for (let i = 0; i < ticket.complaintCodes.length; i++) {
                        fd.append(`complaintCodes`, ticket.complaintCodes[i].id);
                    }
                } else {
                    fd.append(prop, ticket[prop]);
                }
            }
        }
        if (changeEmail && changeEmail.useCustom) {
            fd.append('customEmailAddress[serviceCompany]', changeEmail.serviceCompany);
            fd.append('customEmailAddress[phone]', changeEmail.phone);
            fd.append('customEmailAddress[email]', changeEmail.email);
            fd.append('customEmailAddress[custom]', changeEmail.useCustom);
        }

        var url = `/api/servicetickets/create?number=${number}`

        if (dispatch) {
            url += `&dispatch=${dispatch}`
        }

        return axios.post(url, fd,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    },
    deleteTicket(id) {
        return axios.delete(`/api/servicetickets/${id}`);
    },
    resolveTicket(id) {
        return axios.post(`/api/servicetickets/${id}/resolve`);
    },
    resendTicket(id) {
      //return axios.post('/api/');
    },
    reopenTicket(id) {
        return axios.post(`/api/servicetickets/${id}/reopen`);
    },
    printTicket(id) {
        return axios.get(`/api/servicetickets/${id}/print`);
    },
    submitComment(id, form) {
        return axios.post(`/api/servicetickets/${id}/comments`,
            {
                id: form.commentId,
                message: form.comment
            });
    },
    editServiceTicketStatus(id, ticketStatus) {
        return axios.post(`/api/servicetickets/${id}/editticketstatus`, ticketStatus, {
            headers: { "Content-Type": "application/json" }
        });
    },
    deleteComment(id, comment) {
        return axios.post(`/api/servicetickets/${id}/deletecomment`,
            {
                id: comment.id
            });
    },
    submitWhatWasDone(id, form) {
        return axios.post(`/api/servicetickets/${id}/whatwasdone`,
            {
                id: form.whatWasDoneId,
                message: form.whatWasDone
            });
    },
    deleteWhatWasDone(id, whatWasDone) {
        return axios.post(`/api/servicetickets/${id}/deletewhatwasdone`,
            {
                id: whatWasDone.id
            });
    },
    submitEscalationCommentNextStep(id, form) {
        return axios.post(`/api/servicetickets/${id}/escalationcommentnextstep`,
            {
                id: form.escalationCommentNextStepId,
                message: form.escalationCommentNextStep
            });
    },
    deleteEscalationCommentNextStep(id, escalationCommentNextStep) {
        return axios.post(`/api/servicetickets/${id}/deleteescalationnextstep`,
            {
                id: escalationCommentNextStep.id
            });
    },
    submitEscalationSubscriber(id, form) {
        return axios.post(`/api/servicetickets/${id}/escalationsubscriberupdate`,
            {
                id: form.escalationCommentNextStepId,
                isSubscribedByEmail: form.isSubscribedByEmail,
                isSubsribedBySms: form.isSubsribedBySms
            });
    },
    getStatuses() {
        return axios.get('/api/servicetickets/statuses');
    },
    updateTicket(details) {
        var fd = new FormData();
        fd.append('id', details.id);
        if (details.escalationPart != null) {
            fd.append('escalationNeededPart.salesOrderNumber', details.escalationPart.salesOrderNumber);
            fd.append('escalationNeededPart.trackingNumber', details.escalationPart.trackingNumber);
            fd.append('escalationNeededPart.workflowStage', details.escalationPart.workflowStage);
            fd.append('escalationNeededPart.smsSubscription', details.escalationPart.smsSubscription);
            fd.append('escalationNeededPart.emailSubscription', details.escalationPart.emailSubscription);
            fd.append('escalationNeededPart.escallationContactName', details.escalationPart.escallationContactName);
            fd.append('escalationNeededPart.escallationContactPhone', details.escalationPart.escallationContactPhone);
            fd.append('escalationNeededPart.escallationContactEmail', details.escalationPart.escallationContactEmail);
            fd.append('escalationNeededPart.escalatedBy', details.escalationPart.escalatedBy);
            //fd.append('escalationNeededPart.parts', JSON.stringify(details.escalationPart.parts));
            
            for (let i = 0; i < details.escalationPart.parts.length; i++) {
                console.log(JSON.stringify(details.escalationPart.parts[i].part))
                fd.append('escalationNeededPart.parts[' + i + '].id', details.escalationPart.parts[i].part.id);
                fd.append('escalationNeededPart.parts[' + i + '].quantity', details.escalationPart.parts[i].quantity);
            }

        }
        console.log(fd);
        for (let i = 0; i < details.attachments.length; i++) {
            if (details.attachments[i] instanceof File) {
                fd.append(`attachments`, details.attachments[i]);
            }
            else{
                fd.append(`oldAttachmentIds`, details.attachments[i].id)
            }
        }

        return axios.post(`/api/servicetickets/update`, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getCategories() {
        return axios.get('/api/dashboard/categories/servicetickets');
    },
    getServiceTicketNumber() {
        return axios.get('/api/servicetickets/getnumber');
    },
    getOpenedServiceTicketForEquipmentInLastXDays(idEquipment, days) {
        return axios.get(`/api/servicetickets/getopenedserviceticketforequipmentinlastxdays/${idEquipment}/${days}`);
    },
    getComplaintCodeCategories() {
        return axios.get(`/api/complaintcodes/categories`);
    },
    getPreviousTickets(id, pageNumber, previousTicketsPageSize) {
        return axios.get(`/api/servicetickets/${id}/previoustickets`,
            {
                params: {
                    page: pageNumber,
                    perPage: previousTicketsPageSize
                }
            });
    },
    getServiceCompanyCredentials(id) {
        return axios.get(`/api/servicetickets/${id}/getServiceCompanyCredentials`);
    },
    download(filter) {
        var params = {
            customer: filter.customer,
            ticket: filter.ticket,
            city: filter.city,
            serviceCompany: filter.serviceCompany,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serialNumber: filter.serialNumber,
            state: filter.state,
            source: filter.source,
            chainId:filter.chainId
        };
        if (filter.type !== 0) {
            params.status = filter.type
        }
        return axios.download('/api/servicetickets/export', params);
    },
    sendEmail(id) {
        return axios.get(`/api/servicetickets/${id}/confirmEmailReceived`);
    },
    customerIsRs(id) {
        return axios.get(`/api/servicetickets/${id}/customerIsRs`);
    },
    resendEmail(id, email) {
        return axios.post(`/api/servicetickets/resendEmail/${id}/${email}`);
    },
    accept(id) {
        return axios.post(`/api/servicetickets/accept/${id}`);
    },
    reject(id, reason) {
        return axios.post(`/api/servicetickets/reject/${id}/${reason}`);
    },
    generateAuthNumber(id, form) {
        return axios.post(`/api/servicetickets/${id}/generateAuthNumber`,
            {
                qty: form.qty,
                partNumber: form.partNumber,
                techName: form.techName,
                serviceTicketId: form.serviceTicketId
            });
    },
    getIsPendingPart(id) {
        return axios.get(`/api/servicetickets/${id}/getIsPendingPart`);
    },
    getServiceTicketData(id) {
        return axios.get(`/api/servicetickets/${id}/rma`)
    },
    getParts(term, serviceCompanyId, productId) {
        return axios.get('/api/parts/lookup',
            {
                params: {
                    term: term,
                    serviceCompanyId: serviceCompanyId,
                    productId: productId,
                    unavailableForClaims: true
                }
            });
    },
    getPartById(id, serviceCompanyId, isNotWarrantyClaim) {
        return axios.get(`/api/parts/${id}/${serviceCompanyId}/${isNotWarrantyClaim}/dashboard`);
    },
    updateSubscriber(serviceTicketId, subscriberForm) {
        var fd = new FormData();
        fd.append('serviceTicketId', serviceTicketId);
        subscriberForm.forEach((subscriber, index) => {
            fd.append(`subscribers[${index}].id`, subscriber.id);
            fd.append(`subscribers[${index}].name`, subscriber.name);
            fd.append(`subscribers[${index}].email`, subscriber.email);
            fd.append(`subscribers[${index}].sms`, subscriber.sms);
            fd.append(`subscribers[${index}].isSubscribedByEmail`, subscriber.isSubscribedByEmail);
            fd.append(`subscribers[${index}].isSubscribedBySms`, subscriber.isSubscribedBySms);
        });
        console.log(fd)
        return axios.post(`/api/servicetickets/updatesubscriber`, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    updateEmailStatus(serviceTicketId) {
        return axios.post(`/api/servicetickets/updateEmailStatus/${serviceTicketId}`);
    } 
}



// WEBPACK FOOTER //
// ./ClientApp/app/servicetickets/api.js